import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  products: [],
  cart: [],
  productsById: {}
}

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    pushProducts: (state, action) => {
      state.products = action.payload
    },
    addToCart: (state, action) => {
      console.log(action.payload.cart || 1)
      state.cart.push(action.payload)
      state.productsById[action.payload.slug] = 1
    },
    handleDecrement: (state, action) => {
      const slug = action.payload

      if (state.productsById[slug] === 1) {
        state.cart = state.cart.filter(p => p.slug !== slug)
        delete state.productsById[slug]
      } else {
        state.productsById[slug] -= 1
      }
    },
    handleIncrement: (state, action) => {
      const slug = action.payload
      state.productsById[slug] += 1
    },
    emptyCart: (state) => {
      state.cart = []
      state.productsById = {}
    },
  },
})

export const { pushProducts, addToCart, handleDecrement, handleIncrement, emptyCart } = cartSlice.actions
export default cartSlice.reducer